import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { UsersModel } from "common/models/page-models/users/user-data-model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from 'src/environments/environment';
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class UsersFormDataService extends FormDataService<UsersModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addUser, http, ss);
    }

    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.usersEdit,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
         payload = {
            id: data.id
        }
        return payload;
    }

    createInstance(): UsersModel {
        return new UsersModel();
    }

    // override modifyAPIResponse(response: any) {
    //     return response['details'];
    // }

    override getUpdateUrl() {
        return API_URL.updateUsers;
    }

}

export { FormDataService };
